import { Alert } from '@mm/components';
import { ExclamationTriangleSolidIcon } from '@mm/icons';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './DailyTwilioSoftLimitReachedModal.module.css';

export const DailyTwilioSoftLimitReachedModal = () => {
  const facebookPage = useSelector(activeFacebookPageSelector);
  const twilioSoftDailyLimitReachedAt =
    facebookPage?.currentOutgoingMessagesStatistic
      ?.twilioSoftDailyLimitReachedAt;

  const [showAlert, setShowAlert] = useState(
    moment().isBefore(moment(twilioSoftDailyLimitReachedAt).endOf('day')),
  );

  useEffect(() => {
    const twilioDailyModalDismissedTill = localStorage.getItem(
      'DailyTwilioSoftLimitReachedModal',
    );
    if (twilioDailyModalDismissedTill) {
      const shouldShowAlert = moment(
        twilioSoftDailyLimitReachedAt,
      ).isSameOrAfter(twilioDailyModalDismissedTill);
      setShowAlert(shouldShowAlert);
    }
  }, []);

  const onCloseClick = () => {
    localStorage.setItem(
      'DailyTwilioSoftLimitReachedModal',
      String(moment().endOf('day')),
    );
    setShowAlert(false);
  };
  if (
    !showAlert ||
    !facebookPage?.smsActivated ||
    !facebookPage?.smsNumberActivated ||
    !facebookPage?.currentOutgoingMessagesStatistic ||
    !facebookPage.currentOutgoingMessagesStatistic.twilioSoftDailyLimitReachedAt
  ) {
    return <></>;
  }
  return (
    <div>
      {showAlert && (
        <Alert
          type="error"
          closeIconProps={{ onClick: onCloseClick }}
          css={{ container: styles.container }}
          borderRadius={0}
          hideLeftIcon
          leftIcon={
            <ExclamationTriangleSolidIcon
              className={styles.leftIcon}
              color="#D4380D"
              style={{ width: '21px', height: '18px' }}
            />
          }
        >
          <div className={styles.text}>
            Cellular carriers now require that any campaign sending a high
            volume of messages be registered for their standard: A2P 10DLC.
          </div>
          <div className={styles.text}>
            {' '}
            Please contact you Account Manager (or{' '}
            <a className={styles.link} href="mailto:cs@mobilemonkey.com">
              cs@mobilemonkey.com
            </a>
            ) to register your account and increase your sending limits.
          </div>
        </Alert>
      )}
    </div>
  );
};
